'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _tslib = require('../_virtual/_tslib.js');

var jsxRuntime = require('react/jsx-runtime');

var react = require('react');

var Icon = function Icon(_a) {
  var icon = _a.icon,
      _b = _a.color,
      color = _b === void 0 ? "black" : _b,
      size = _a.size,
      _c = _a.width,
      width = _c === void 0 ? size : _c,
      _d = _a.height,
      height = _d === void 0 ? size : _d,
      _e = _a.basePath,
      basePath = _e === void 0 ? process && process.env && process.env.PRISMEAI_ICONS_PATH || "@prisme.ai/icons" : _e,
      style = _a.style,
      props = _tslib.__rest(_a, ["icon", "color", "size", "width", "height", "basePath", "style"]);

  var ref = react.useRef(null);

  var _f = react.useState(""),
      svg = _f[0],
      setSvg = _f[1];

  var fetchSvg = react.useCallback(function () {
    return _tslib.__awaiter(void 0, void 0, void 0, function () {
      var res, _a;

      return _tslib.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , fetch(basePath + "/" + icon + ".svg")];

          case 1:
            res = _b.sent();
            if (res.status !== 200) throw new Error("not found");
            _a = setSvg;
            return [4
            /*yield*/
            , res.text()];

          case 2:
            _a.apply(void 0, [_b.sent()]);

            return [3
            /*break*/
            , 4];

          case 3:
            _b.sent();

            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  }, [basePath, icon]);
  react.useEffect(function () {
    if (!ref.current) return;
    ref.current.innerHTML = svg.replace("{props.color}", color);
    var svgEl = ref.current.querySelector("svg");
    if (!svgEl) return;
    svgEl.setAttribute("width", "100%");
    svgEl.setAttribute("height", "100%");
    svgEl.style.fill = color;
  }, [color, svg]);
  react.useEffect(function () {
    fetchSvg();
  }, [fetchSvg]);
  return jsxRuntime.jsx("div", _tslib.__assign({
    ref: ref
  }, props, {
    style: _tslib.__assign({
      height: height + "px",
      width: width + "px",
      display: "inline-block"
    }, style)
  }), void 0);
};

exports.Icon = Icon;
exports["default"] = Icon;